"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    gatewayJwtService: ()=>external_gateway_jwt_service_js_namespaceObject.gatewayJwtService,
    getGatewayConfig: ()=>external_gateway_config_polyfill_js_namespaceObject.getGatewayConfig,
    createHandleGatewayRequest: ()=>external_gateway_util_js_namespaceObject.createHandleGatewayRequest,
    gatewayService: ()=>external_gateway_service_js_namespaceObject.gatewayService
});
const external_gateway_jwt_service_js_namespaceObject = require("./gateway-jwt.service.js");
const external_gateway_config_polyfill_js_namespaceObject = require("./gateway-config.polyfill.js");
const external_gateway_util_js_namespaceObject = require("./gateway.util.js");
const external_gateway_service_js_namespaceObject = require("./gateway.service.js");
exports.createHandleGatewayRequest = __webpack_exports__.createHandleGatewayRequest;
exports.gatewayJwtService = __webpack_exports__.gatewayJwtService;
exports.gatewayService = __webpack_exports__.gatewayService;
exports.getGatewayConfig = __webpack_exports__.getGatewayConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "createHandleGatewayRequest",
    "gatewayJwtService",
    "gatewayService",
    "getGatewayConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
